export function Spinner({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="spinner" role="status" aria-live="polite">
      <span className="spinner__dot" />
      <span className="spinner__label">{label}</span>
    </div>
  );
}

/** Fallback for lazily-loaded routes. */
export function RouteFallback() {
  return (
    <div className="route-fallback">
      <Spinner label="Loading section" />
    </div>
  );
}
